import { Form, Select, message, Col, Row, Input, Typography, Modal, Checkbox, Space, Divider } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import {
  EditOutlined,
  DislikeOutlined,
  LikeOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import http from "../../../services/http";
const { TextArea } = Input;
const { Text, Paragraph } = Typography;

const options_status_acoes = [
  {
    value: -1,
    label: (
      <Text style={{ color: "#ff4d4f" }}>
        <DislikeOutlined /> Não aceito para realização
      </Text>
    ),
  },
  {
    value: 2,
    label: (
      <Text style={{ color: "#60b565" }}>
        <LikeOutlined /> Aceito para realização
      </Text>
    ),
  },
  {
    value: 0,
    label: (
      <Text style={{ color: "#ff4d4f" }}>
        <CloseCircleOutlined /> Não alcançado
      </Text>
    ),
  },
  {
    value: 1,
    label: (
      <Text style={{ color: "#60b565" }}>
        <CheckCircleOutlined /> Alcançado
      </Text>
    ),
  },
  {
    value: 3,
    label: (
      <Text style={{ color: "#1677ff" }}>
        <ClockCircleOutlined /> Aguardando Avaliação
      </Text>
    ),
  },
];

const rulesValidation = {
  status: [{ required: true, message: "Informe o status!" }],
  parecer: [{ required: true, message: "Informe o parecer!" }],
};

const ProblemasAvaliacoesTableForm = ({ open, id, onFinish, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);

  useEffect(() => {
    if (open && id > 0) {
      carregarAcaoAvaliacao(id);
    }
  }, [open]);

  const carregarAcaoAvaliacao = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/problemas_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setDados(response);
      form.resetFields();
      form.setFieldsValue({
        status: response?.status,
      });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const cadastrarAcaoAvaliacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_acoes/adicionar_parecer`, formulario);
    if (api.statusCode === 200) {
      message.success("Avaliação registrada com sucesso!");
      form.resetFields();
      setDados(null);
      onFinish();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    if (!(id > 0)) return;
    formulario.status = formulario?.status?.toString();
    formulario.id = id;
    cadastrarAcaoAvaliacao(formulario);
  };

  const handleClose = useCallback(() => {
    form.resetFields();
    setDados(null);
    onClose();
  }, []);

  return (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> Adicionar Parecer
        </Text>
      }
      open={open}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={handleClose}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Space direction="vertical">
              <Text style={{ fontSize: 18, color: "#60b565" }} strong>
                Ação (Como?)
              </Text>
              <Paragraph
                className="line-break"
                ellipsis={{
                  rows: 3,
                  expandable: true,
                }}>
                {dados?.descricao}
              </Paragraph>
            </Space>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Space direction="vertical">
              <Text style={{ fontSize: 18, color: "#60b565" }} strong>
                Observações
              </Text>
              <Paragraph
                className="line-break"
                ellipsis={{
                  rows: 3,
                  expandable: true,
                }}>
                {dados?.observacoes ?? "-"}
              </Paragraph>
            </Space>
          </Col>

          <Divider />

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={rulesValidation.status}>
              <Select size="large" placeholder="Selecione o status" disabled={loading} options={options_status_acoes} />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item label="Parecer" name="parecer" rules={rulesValidation.parecer}>
              <TextArea
                size="large"
                autoSize={{ minRows: 4, maxRows: 5 }}
                placeholder="Informe o parecer"
                disabled={loading}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item name="enviar_notificacao" valuePropName="checked">
              <Checkbox disabled={loading}>Enviar Notificações</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export { ProblemasAvaliacoesTableForm };
